<script>
    import {createEventDispatcher} from 'svelte';
    export let value = '';
    export let placeholder = '';
    export let border = true;

    const dispatch = createEventDispatcher();

    function onKeyUp(event){
        if(event.key === 'Enter'){
            dispatch('enterPressed', {value});
        }
    }
</script>

<style>
    .auto-complete-wrapper {
        width: 100%;
    }

    .auto-complete-wrapper input {
        width: 100%;
    }

    .borderless {
        border: none;
        outline: none;
    }
</style>

<div class="auto-complete-wrapper">
    <input
            type="text"
            class:borderless={!border}
            {placeholder}
            on:keyup={onKeyUp}
            on:focus
            on:blur
            bind:value />
</div>